var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-nsfw"},[_c('unicon',{class:(_vm.state) ? 'activated' : '',attrs:{"name":"18-plus"},nativeOn:{"click":function($event){return _vm.toggle.apply(null, arguments)}}}),(_vm.displayAgePopUp)?_c('NSFWVerificationPopUp',{on:{"yes":_vm.toggle,"no":function($event){_vm.displayAgePopUp = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }